import React from 'react';
import { StyledCard } from '../atoms/styles';
import Eyebrow from '../atoms/text/Eyebrow';
import Title from '../atoms/text/Title';
import DescriptionText from '../atoms/text/DescriptionText';
import LinkButton from '../atoms/LinkButton';
import PropTypes from 'prop-types';
import Footnote from '../atoms/text/Footnote';

const Card = ({
  className,
  image,
  status,
  eyebrow,
  title,
  description,
  href,
  footnote,
  cta,
  showPlayIcon,
  ariaLabel,
  xl
}) => (
  <StyledCard className={className} showPlayIcon={showPlayIcon}>
    <div className="image_container">
      <a href={href} aria-label={ariaLabel}>
        {image}
      </a>
    </div>
    <div className="content_container">
      <a href={href}>
        {status}
        {eyebrow && <Eyebrow text={eyebrow} />}
        {title && <Title text={title} xl={xl} element="h3" />}
        {description && (
          <DescriptionText text={description} xl={xl} truncateLines={3} />
        )}
        {footnote && <Footnote text={footnote} />}
      </a>
      {cta?.text &&
        cta?.href && (
          <LinkButton href={cta.href} secondary>
            {cta.text}
          </LinkButton>
        )}
    </div>
  </StyledCard>
);

Card.propTypes = {
  className: PropTypes.string,
  image: PropTypes.node.isRequired,
  status: PropTypes.node,
  eyebrow: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  href: PropTypes.string.isRequired,
  showPlayIcon: PropTypes.bool,
  footnote: PropTypes.string,
  cta: PropTypes.shape({
    text: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired
  }),
  ariaLabel: PropTypes.string,
  xl: PropTypes.bool
};

Card.defaultProps = {
  className: null,
  description: null,
  title: null,
  status: null,
  eyebrow: null,
  showPlayIcon: undefined,
  footnote: undefined,
  cta: undefined,
  ariaLabel: undefined,
  xl: undefined
};
export default Card;
